module.exports = __WEBPACK_EXTERNAL_MODULE_55__;


//////////////////
// WEBPACK FOOTER
// external {"root":["ng","animations"],"commonjs":"@angular/animations","commonjs2":"@angular/animations","amd":"@angular/animations"}
// module id = 55
// module chunks = 0